export default __webpack_public_path__ + "static/media/warning-bus.b867f32c.svg";